import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { SandboxHistoryJsonModel } from '../../domain/stream/transaction/TransactionDomains';

export type SandboxActions = 'SET_HISTORIES' | 'CLEAR_HISTORIES' | 'SET_HISTORY_DATE';

export const setHistories = (payload: SandboxHistoryJsonModel) =>
  ({
    type: 'SET_HISTORIES',
    payload,
  }) as ReduxBaseAction<any, SandboxActions>;

export const setHistoryDate = (payload: string) =>
  ({
    type: 'SET_HISTORY_DATE',
    payload,
  }) as ReduxBaseAction<any, SandboxActions>;

export const clearHistories = () =>
  ({
    type: 'CLEAR_HISTORIES',
    payload: 0,
  }) as ReduxBaseAction<any, SandboxActions>;
